module.exports = __webpack_public_path__ + "img/crown.026b6df6.gif";